import React from 'react';
import classNames from 'classnames';
import imageGalleryStyles from '../../../views/ProductDetails/Series3CollarDetails/components/ImageGallery/ImageGallery.module.scss';
import ImageGallery from '../../ImageGallery/ImageGallery';
import { IImage, IVideo } from '../../../types';

const DEFAULT_ULTRA_IMAGES: IImage[] = [
  {
    type: 'image',
    url: '/product_images/ultra/ultra-01.png',
    descriptors: ['1500w', '3000w', '4000w'],
  },
  {
    type: 'image',
    url: '/product_images/ultra/ultra-02.png',
    descriptors: ['1500w', '3000w', '4000w'],
  },
  {
    type: 'image',
    url: '/product_images/ultra/ultra-03.png',
    descriptors: ['1500w', '3000w', '4000w'],
  },
  {
    type: 'image',
    url: '/product_images/ultra/ultra-04.png',
    descriptors: ['1500w', '3000w', '4000w'],
  },
  {
    type: 'image',
    url: '/product_images/ultra/ultra-05.png',
    descriptors: ['1500w', '3000w', '4000w'],
  },
  {
    type: 'image',
    url: '/product_images/ultra/ultra-06.png',
    descriptors: ['1500w', '3000w', '4000w'],
  },
  {
    type: 'image',
    url: '/product_images/ultra/ultra-07.png',
    descriptors: ['1500w', '3000w', '4000w'],
  },
];

interface UltraDesktopImageGalleryProps {
  /** Dynamic images from API - if provided, overrides hardcoded images */
  dynamicImages?: (IImage | IVideo)[] | null;
  prevNextButtons?: boolean;
  /** Extra slides appended after the product photos, e.g. the device's own video. */
  appendMedia?: (IImage | IVideo)[];
  /** Glide to the tapped thumbnail instead of cutting to it. */
  animateThumbnailSelect?: boolean;
}

export default function UltraDesktopImageGallery({
  dynamicImages,
  prevNextButtons,
  appendMedia,
  animateThumbnailSelect,
}: UltraDesktopImageGalleryProps) {
  // Use dynamic images if provided, otherwise fall back to defaults
  const media = dynamicImages ?? DEFAULT_ULTRA_IMAGES;
  const galleryMedia = appendMedia ? [...media, ...appendMedia] : media;

  return (
    <div
      className={classNames(imageGalleryStyles.imageGalleryContainer, imageGalleryStyles.desktopImageGallery)}
      style={{ borderRadius: 0 }}
    >
      <ImageGallery
        media={galleryMedia}
        pageDots={true}
        disableAnimation={!animateThumbnailSelect}
        friction={0.4}
        noBorderRadius={true}
        prevNextButtons={prevNextButtons}
      />
    </div>
  );
}
